import { includes } from 'lodash-es'

import { TriageScreenerNames } from '../../../models'
import { CustomerName } from '../../common/constants/customer'
import { usePrevious } from '../../common/hooks/usePrevious'
import { SEARCHER_TYPE_TO_MATCH_FOR } from '../../searchForCare/constants'
import {
  sendMultiplePrimaryNeedsExperimentData,
  SendMultiplePrimaryNeedsExperimentDataParams,
} from '../sendMultiplePrimaryNeedsExperimentData'

/**
 * Hook that sends experiment data for the Multiple Primary Needs experiment during triage.
 *
 * This hook fires when the user views the primary needs triage screener and then sends
 * experiment data to both our experiment pipeline and launchdarkly. The experiment data
 * should only be sent for self searchers (adult and teen) and not for Lyra Select users
 * or excluded customer (starbucks).
 */

type UseSendMultiplePrimaryNeedsExperimentDataTriage = SendMultiplePrimaryNeedsExperimentDataParams & {
  selectedTriageMetadataName: TriageScreenerNames
  matchFor: SEARCHER_TYPE_TO_MATCH_FOR
}

const customerExlusions = [CustomerName.STARBUCKS]

export const useSendMultiplePrimaryNeedsExperimentDataTriage = ({
  selectedTriageMetadataName,
  canSelectMultiplePrimaryNeeds,
  userId,
  searchId,
  deviceUUID,
  customerName,
  postExperimentEntrypoint,
  ldClient,
  isLyraSelect,
  matchFor,
  origin,
}: UseSendMultiplePrimaryNeedsExperimentDataTriage) => {
  const previousTriageMetadataName = usePrevious(selectedTriageMetadataName)
  if (
    previousTriageMetadataName !== selectedTriageMetadataName &&
    selectedTriageMetadataName === TriageScreenerNames.PRIMARY_NEEDS &&
    !isLyraSelect &&
    !includes(customerExlusions, customerName) &&
    matchFor === SEARCHER_TYPE_TO_MATCH_FOR.SELF
  ) {
    sendMultiplePrimaryNeedsExperimentData({
      canSelectMultiplePrimaryNeeds,
      userId,
      searchId,
      deviceUUID,
      customerName,
      postExperimentEntrypoint,
      ldClient,
      isLyraSelect,
      origin,
    })
  }
}
